import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class BackGround extends Vue {
  @Prop({ default: () => {} })
    value: DisplayBgData;

  @Prop()
    disabled: boolean;

  render(h) {
    return (
      // 暂时图片不截取 + "?imageView2/1/w/750/h/400"
      <div class="user-info" style={{ background: this.value.desc.val }}>
        {this.value.desc.type === 2 && <img src={this.value.desc.val} style="position: absolute;width: inherit;" />}
        <div class="header-img">
          <i class="iconfont iconmorentouxiang font-size-50" style="color: #D6DCFD"></i>
        </div>
        <div class="base-info" style={`color: ${this.value.desc.color}`}>
          <p>
            会员昵称<span class="user-identity">顾客</span>
          </p>
          <p>网点名称</p>
        </div>
      </div>
    );
  }
}
